<template>
<div>
    <!-- <input type="text" id="attachment" class="border rounded" ref="attachment" v-on:change="upload()"> -->
    <b-form-textarea id="textarea1"
                     v-model="text"
                     :rows="3"
                     :max-rows="6">
    </b-form-textarea>
    <b-button @click="save()" class="mt-2 float-right">Save</b-button>
</div>
</template>

<script>
    export default {
        props: {
            url: {default:''},
            modelClass: {default:''},
            id: {default: null}
        },
        data: function() {
            return {
                text: ''
            }
        },
        methods: {
            save() {
                if (this.text == null || this.text == '') return
                
                window.axios.post(
                    '/api/comment/', {
                        id: this.id,
                        text: this.text,
                        model: this.modelClass
                    }
                ).then(({data})=>{
                    console.log(data)
                    if(data.msg == 'done') {
                        this.text = ''
                        this.$emit('change',true)
                    }
                }).catch((error)=>{
                    console.log(error)
                }).then(()=>{
                    // this.$refs.attachment.value = ''
                })
                
            }
        },
        beforeCreate() {
        },
        mounted() {
        }
    }
</script>
